/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enrollment_Load_ErrorInputs */

const en_enrollment_load_error = /** @type {(inputs: Enrollment_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load enrollment`)
};

const ja_enrollment_load_error = /** @type {(inputs: Enrollment_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登録情報の読み込みに失敗しました`)
};

const fr_enrollment_load_error = /** @type {(inputs: Enrollment_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec du chargement de l'inscription`)
};

const de_enrollment_load_error = /** @type {(inputs: Enrollment_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Laden der Einschreibung`)
};

/**
* | output |
* | --- |
* | "Failed to load enrollment" |
*
* @param {Enrollment_Load_ErrorInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const enrollment_load_error = /** @type {((inputs?: Enrollment_Load_ErrorInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enrollment_Load_ErrorInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enrollment_load_error(inputs)
	if (locale === "ja") return ja_enrollment_load_error(inputs)
	if (locale === "fr") return fr_enrollment_load_error(inputs)
	return de_enrollment_load_error(inputs)
});